import { auth, db, storage } from "../firebase";
import { getAuth, updateProfile } from "firebase/auth";
import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { ref, listAll, getDownloadURL } from "firebase/storage";

export async function updateRole(user, role) {
  try {
    // Ensure user is authenticated
    if (!user) {
      throw new Error("User is not authenticated.");
    }

    // Update the user's profile with the new display name
    await user.updateProfile({
      role: role,
    });

    // Profile updated successfully
    console.log("Role updated successfully");
  } catch (error) {
    // Handle errors
    console.error("Error updating Role from syncImages.js:", error);
  }
}

export async function updateDisplayName(user, newDisplayName) {
  try {
    // Ensure user is authenticated
    if (!user) {
      throw new Error("User is not authenticated.");
    }

    // Update the user's profile with the new display name
    await updateProfile(user, { displayName: newDisplayName });

    // Profile updated successfully
    console.log("Display name updated successfully");
  } catch (error) {
    // Handle errors
    console.error("Error updating display name:", error);
  }
}

// Function to update an artist document with a new imageURL
export async function updateArtistImageURL(docId, newImageURL) {
  try {
    // Get a reference to the artist document by docId
    const artistRef = db.collection("artists").doc(docId);

    // Use set to update the imageURLs field with a new array containing the new URL
    // We use merge: true to merge the new data with the existing document
    await artistRef.set(
      {
        imageURLs: [newImageURL],
      },
      { merge: true }
    );

    console.log("Documents have been synced successfully");
    return true;
  } catch (error) {
    console.error("Error updating document:", error);
    return false;
  }
}

export async function syncImageUrls(collectionName, docId, storageUrls) {
  console.log("SyncImages CollectionName:", collectionName);
  console.log("SyncImages DocId:", docId);
  //setDocId(docId);
  console.log("FROM SyncImage URLs imageUrls:", storageUrls);
  console.log("Type of storageUrls:", typeof storageUrls);

  try {
    const documentRef = doc(db, "artists", docId);
    await updateDoc(documentRef, {
      imageURLs: storageUrls,
    });
    console.log(
      `Updated Firestore document ${docId} with new imageUrls, called from syncImages`
    );
    return true;
  } catch (error) {
    console.error("Error updating Firestore document:", error);
    return false;
  }
}

export async function getStorageUrls(folderName) {
  try {
    // Reference to the folder in Firebase Storage
    const folderRef = ref(storage, `images/${folderName}/`);
    //const folderRef = ref(storage, folderName);
    // List all the items (files and directories) in the folder
    const items = await listAll(folderRef);
    // Get the download URLs for each image file in the folder
    const imageUrls = await Promise.all(
      items.items.map(async (item) => {
        const downloadUrl = await getDownloadURL(item);
        // Extract the image URL from the download URL
        const imageUrl = downloadUrl.split("?alt=")[0];

        return imageUrl;
        //return downloadUrl;
      })
    );

    // Return the array of download URLs
    console.log("From Function downLoad Urls STORAGE", imageUrls);
    return imageUrls;
  } catch (error) {
    console.error("Error getting URLs of images in folder:", error);
    throw error;
  }
}
